import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './rankingnps.scss'
import Filter from './filter/filter'
import Grafico from './grafico'
import { carregarGrafico, filterHandle } from './redux/rankingnpsActions'
import { setInfoGrupo, setProjeto } from '../../../layout/redux/layoutActions'
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'


export default () => {
  const dispatch = useDispatch()
  const { grupos, grupo, filters, filterActive, sistema } = useSelector(state=> state.layoutState)
  const { projeto, grafico, totalAvaliacao, projetos } = useSelector(state=> state.rankingnpsState)

  const nls = require(`../rankingnps/nls/${sistema.idioma}.json`)
  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)


  const labelgraf = {
    atual: nls.labelgrafico.atual,
    anterior: nls.labelgrafico.anterior
  };

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])



  useEffect(()=> {
    if (projeto.id&& !grafico.length) {
      if (filters.typeSelect) {
        dispatch(filterHandle({projetoID: projeto.id, grupo, params: filters, filterActive, typeSelect: filters.typeSelect, idioma: sistema.idiomaIdValue, labelgraf }))
      } else {
        dispatch(carregarGrafico({projetoID: projeto.id, grupo, params: {TipoBusca: 'Ciclo', MesCliclo: '2023-01', Comparacao: true}, idioma: sistema.idiomaIdValue, labelgraf }))
      }
    }
  }, [projeto, grupo, sistema.idiomaIdValue])

  const handleFormFilter = (e) => {
    dispatch(setProjeto(e.value))
  }
  const handleGrupo = (e) => {
    dispatch(setInfoGrupo(e.value))
  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}

  
  return (
    <div className='box-rankingnps' data-cy='page-npsstorescompetitors'>
      <div className='box-rankingnps-topinfo'>
        <div>
          <div className='box-rankingnps-topinfo-select'>
            <Select 
              name='projeto'
cy='filter-project'
label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormFilter(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          <div className='box-rankingnps-topinfo-select'>
            {/* <label>Cliente: </label> 
            <span> {projeto?.empresa}</span> */}
          </div>


          {grupos && grupos.some(g => g?.name && g.name.trim() !== '') ? (
            <div className='box-rankingnps-topinfo-select'>
              <Select 
  name='grupo'
  cy='filter-group'
  label={nls.grupo}
                options={grupos}
                selected={grupo}
                action={(e)=> handleGrupo(e)}
                selectedItem={false}
              />
            </div>
          ) : null}




        </div>
        <div className='box-rankingnps-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong data-cy='feedback-count'>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video7" cy="tutorial" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
  cy="dashboard-create-open"
  onClick={handleAbrirCriarDashboard}
/>
        )}

      </div>
      
      <Grafico nlsContexto={nlsContexto} labelgraf={labelgraf} nls={nls} imprimir={totalAvaliacao > 0}/>

      <Criar />
      
    </div>
  )
}
